<template>
    <Card title="Faturas Pagas" icon="ion ion-ios-document">
        <button class="btn btn-block btn-lg btn-secondary" @click="$refs.recebimentos.open()">GERAR</button>

        <vuestic-modal ref="recebimentos" v-bind:small="false" :cancelClass="'none'" :okClass="'none'">
            <span slot="header"> Selecione o Periodo </span>
            <div class="form-group" v-if="!btn_load">
                <div class="col-md-6">
                    <input type="date" id='dataInicial' v-model="data_inicio" :max='now'>
                </div>
                <div class="col-md-6">
                    <input type="date" id='dataFinal' v-model="data_final" :max='now'>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-12 d-flex justify-content-center" v-if="!btn_load">
                    <button v-if="!btn_download" id='btn_download_pdf' @click="loadData('pdf')" class="btn btn-primary btn-micro">DOWNLOAD PDF</button>
                    <button v-else id='btn_download_pdf' class="btn btn-primary btn-micro" disabled>DOWNLOAD PDF</button>
                    <button v-if="!btn_download" id='btn_download_csv' @click="loadData('csv')" class="btn btn-primary btn-micro">DOWNLOAD CSV</button>
                    <button v-else id='btn_download_csv' class="btn btn-primary btn-micro" disabled>DOWNLOAD CSV</button>
                    <button v-if="!btn_download" id='btn_download_xlsx' @click="loadData('xlsx')" class="btn btn-primary btn-micro">DOWNLOAD XLSX</button>
                    <button v-else id='btn_download_xlsx' class="btn btn-primary btn-micro" disabled>DOWNLOAD XLSX</button>
                </div>
                <div v-else class="col-md-12 d-flex justify-content-center">
                    <div class="btn-toolbar d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                        <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                    </div>
                </div>
            </div>
        </vuestic-modal>
    </Card>
</template>

<script>
import * as spinners from 'epic-spinners'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import urlApi from '../../../../router/urlApiV2'
import Card from '../../../cards/card.vue';

export default {
    name: 'relatorioAdmin',
    components: {
        ...spinners,
        DateIconGroup,
        Card,
    },

    data () {
        return {
            data_inicio:    '',
            data_final:     '',
            btn_load:       false,
            now:            '',
            btn_download:   true,
        }
    },

    methods:{
        loadData(type){
            this.btn_load   =   true;
            let url =   urlApi + '/faturamento/exportar/recebimentos?periodo[]='+this.data_inicio+'&periodo[]='+this.data_final+'&tipo='+type;
            if(type == 'pdf') {
                this.$http.get(url)
                .then(this.callBackLoadDataPDF)
                .catch(function (error) {
                    this.btn_load   =   false;
                    this.$toasted.show(error.data.mensagem, {
                        position: 'top-right',
                    })
                })
            }else if(type == 'csv') {
                this.$http.get(url)
                .then(this.callBackLoadDataCSV)
                .catch(function (error) {
                    this.btn_load   =   false;
                    this.$toasted.show(error.data.mensagem, {
                        position: 'top-right',
                    })
                })
            }else if(type == 'xlsx') {
                let anchor = document.createElement("a");
                document.body.appendChild(anchor);

                this.$http.get(url, {responseType: 'blob'})
                .then(response => response.blob())
                .then(responseBlob => {
                    console.log(responseBlob)
                    let objectUrl = window.URL.createObjectURL(responseBlob);
                    anchor.href = objectUrl;
                    anchor.download = 'faturas-pagas.xlsx';
                    anchor.click();
                    window.URL.revokeObjectURL(objectUrl);
                    this.btn_load = false;
                });
            }
        },
        callBackLoadDataPDF(response)
        {
            this.downloadPDF(response.body.arquivo)
            this.btn_load   =   false;
        },
        callBackLoadDataCSV(response)
        {
            this.downloadCSV(response.body.arquivo)
            this.btn_load   =   false;
        },
        getDate(){
            let date = new Date()
            let day = String(date.getDate()).padStart(2, '0')
            let month = String(date.getMonth() + 1).padStart(2, '0')
            let year = date.getFullYear()
            this.now    =   year + '-' + month + '-' + day
        },
        downloadPDF (response) {
        let code64 = response
        var pdf = 'data:application/octet-stream;base64,' + code64
        var dlnk = document.getElementById('download')
        dlnk.download = 'valor_recebido_periodo.pdf'
        dlnk.href = pdf
        dlnk.click()
        },
        downloadCSV(response){
            var dlnk = document.getElementById('download');
            dlnk.download="pagamento_recebido.csv";
            dlnk.href = 'data:text/csv;charset=utf-8,' + response;
            dlnk.click();
        },
    },

    mounted() {
        this.getDate()
    },

    watch: {
        data_inicio(date_new){
            if(date_new != '' && this.data_final != '')
            {
                if(new Date(date_new) > new Date(this.data_final))
                {
                    this.$toasted.show('Data inicial deve ser menor do que a data final', {
                        position: 'top-right',
                    });
                    this.data_inicio = '';
                }else
                {
                    this.btn_download    =   false
                }
            }else
            {
                    this.btn_download    =   true
            }
        },
        data_final(date_new){
            if(date_new != '' && this.data_final != '')
            {
                if(new Date(date_new) < new Date(this.data_inicio))
                {
                    this.$toasted.show('Data final deve ser maior do que a data inicial', {
                        position: 'top-right',
                    });
                    this.data_final = '';
                }else
                {
                    this.btn_download    =   false
                }
            }else
            {
                    this.btn_download    =   true
            }
        },
    }
}
</script>
